export default "__VITE_ASSET__517f3c5d__"